import styled from "styled-components";
import { StyledOutlinedButton } from "../../../../../components/Button/button-outlined";
import { Input } from "../../../../../components/Input/input";
import { StyledActiveFormButton } from "../active-button/active-form-button";
import {
  CustomInformationsHelperText,
  CustomInformationsWrapper,
} from "../checkboxes-section/checkboxes-section";
import FormFieldInfo from "../form-field-info/form-field-info";

interface ButtonsSectionProps {
  currentValue: string;
  buttonsOptions: string[];
  popoverLabel: string;
  popoverContent: string;
  formik?: any;
  helperFieldDisplay?: boolean;
  helperFieldName?: string;
  setCurrentValue: (element: string) => void;
}

const ButtonsSection = ({
  currentValue,
  buttonsOptions,
  popoverLabel,
  popoverContent,
  formik,
  helperFieldDisplay,
  helperFieldName,
  setCurrentValue,
}: ButtonsSectionProps) => {
  return (
    <ButtonsSectionContainer>
      <FormFieldInfo
        popoverLabel={popoverLabel}
        popoverContent={popoverContent}
      />

      <ButtonsWrapper>
        {buttonsOptions.map((option) =>
          currentValue === option ? (
            <StyledActiveFormButton key={option} variant="contained">
              {option}
            </StyledActiveFormButton>
          ) : (
            <StyledOutlinedButton
              key={option}
              onClick={() => setCurrentValue(option)}
              variant="outlined"
            >
              {option}
            </StyledOutlinedButton>
          )
        )}
      </ButtonsWrapper>
      {helperFieldDisplay && (
        <CustomInformationsWrapper>
          {helperFieldName === "goodsTypeDescription" ? (
            <>
              <Input
                label="Zacznij pisać..."
                id={helperFieldName}
                name={helperFieldName}
                value={formik.values.goodsTypeDescription}
                onChange={formik.handleChange}
                error={
                  formik.touched.goodsTypeDescription &&
                  Boolean(formik.errors.goodsTypeDescription)
                }
                helperText={
                  formik.touched.goodsTypeDescription &&
                  formik.errors.goodsTypeDescription
                }
                onBlur={formik.handleBlur}
                variant="filled"
                style={{ width: "100%" }}
              />
              <CustomInformationsHelperText>
                {formik.values.goodsTypeDescription ? null : `Pole wymagane*`}
              </CustomInformationsHelperText>
            </>
          ) : (
            <>
              <Input
                label="Zacznij pisać..."
                id={helperFieldName}
                name={helperFieldName}
                value={formik.values.specialEquipmentDescription}
                onChange={formik.handleChange}
                error={
                  formik.touched.specialEquipmentDescription &&
                  Boolean(formik.errors.specialEquipmentDescription)
                }
                helperText={
                  formik.touched.specialEquipmentDescription &&
                  formik.errors.specialEquipmentDescription
                }
                onBlur={formik.handleBlur}
                variant="filled"
                style={{ width: "100%" }}
              />
              <CustomInformationsHelperText>
                {formik.values.specialEquipmentDescription
                  ? null
                  : `Pole wymagane*`}
              </CustomInformationsHelperText>
            </>
          )}
        </CustomInformationsWrapper>
      )}
    </ButtonsSectionContainer>
  );
};

export default ButtonsSection;

const ButtonsSectionContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
`;
